<template lang="pug">

v-container(fluid)
    v-card(class="optimization-parameters-card pa-0 mb-4 mt-1" light)
        .optimization-header.pa-3.d-flex.align-center
            v-icon.mr-2(color="primary" size="28") tune
            span.text-h6.font-weight-bold Optimization Parameters
        v-divider
        v-list(dense class="pa-2")
            v-list-item
                v-list-item-icon
                    v-icon(:color="optimizationStats?.foundFeasible ? 'success' : 'error'") check_circle
                v-list-item-content
                    v-list-item-title Found feasible solution
            v-list-item
                v-list-item-content
                    v-list-item-title Total Attempts: {{ optimizationStats?.totalAttempts }}
            v-list-item
                v-list-item-content
                    v-simple-table(class="params-table")
                        thead
                            tr
                                th Parameter
                                th Config
                                th Optimal
                                th Info
                        tbody
                            tr
                                th Production Max
                                    sup {{optimizationOriginalParameters.prodUom}}
                                td {{optimizationOriginalParameters.productionMax }}
                                td {{optimizationParameters.productionMax }}
                                td
                                    v-tooltip(bottom :max-width="320" :color="'grey darken-4'" transition="scale-transition")
                                        template(v-slot:activator="{ on, attrs }")
                                            span(v-bind="attrs" v-on="on" class="tooltip-activator") Atts: {{optimizationStats.productionMinAttempt }}
                                        div(class="custom-tooltip")
                                            span Number of attempts to minimize production below the configured maximum.
                                                |  A higher number indicates more effort was needed to find a solution.

                            tr
                                th Storage Max
                                    sup {{optimizationOriginalParameters.storageUom}}
                                td {{optimizationOriginalParameters.storageMax }}
                                td {{optimizationParameters.storageMax }}
                                td
                                    v-tooltip(bottom :max-width="320" :color="'grey darken-4'" transition="scale-transition")
                                        template(v-slot:activator="{ on, attrs }")
                                            span(v-bind="attrs" v-on="on" class="tooltip-activator") HB: {{ optimizationStats.hitBounds.storageMaxLower }}
                                        div(class="custom-tooltip")
                                            span When true, storage is capped at the configured maximum.
                                                |  The optimizer did not reduce below this cap.
                                                |  To allow a lower value, adjust configuration.
                            tr
                                th Storage Min
                                    sup {{optimizationOriginalParameters.storageUom}}
                                td {{optimizationOriginalParameters.storageMin }}
                                td {{optimizationParameters.storageMin }}
                                td
                                    v-tooltip(bottom :max-width="320" :color="'grey darken-4'" transition="scale-transition")
                                        template(v-slot:activator="{ on, attrs }")
                                            span(v-bind="attrs" v-on="on" class="tooltip-activator") HB: {{ optimizationStats.hitBounds.storageMinLower }}
                                        div(class="custom-tooltip")
                                            span When true: storage reserve held at the configured minimum.
                                                |  It cannot go lower without a configuration change.
</template>

<style lang="css" scoped>

    .optimization-parameters-card {
        background: linear-gradient(135deg, #e3f2fd 0%, #f5f5f5 100%);
        border: 1px solid #1976D2;
        color: #115293;
        border-radius: 14px;
        box-shadow: 0 4px 16px rgba(25, 118, 210, 0.10);
        overflow: hidden;
        max-height: 420px; /* Adjust as needed to match FlowChart height */
        display: flex;
        flex-direction: column;
    }
    .optimization-header {
        /* background: linear-gradient(90deg, #00355c 0%, #42a5f5 100%); */
        background-color: #00355c;
        color: #fff;
        border-top-left-radius: 14px;
        border-top-right-radius: 14px;
        font-size: 1.15em;
        letter-spacing: 0.5px;
    }
    .optimization-parameters-card .v-list {
        overflow-y: auto;
        flex: 1 1 auto;
        max-height: 320px; /* Ensures list scrolls if content overflows */
    }
    .optimization-parameters-card .v-list-item {
        padding: 2px 0 2px 8px;
        border-radius: 6px;
        margin-bottom: 0;
    }
    .optimization-parameters-card .v-list-item-title {
        font-weight: 600;
        color: #00355c;
        font-size: 1em;
    }
    .optimization-parameters-card .v-list-item-subtitle {
        color: #333;
        font-size: 0.95em;
    }
    .optimization-parameters-card .v-list-item-icon {
        margin-right: 10px;
    }

    /* Ensure v-simple-table header is bold (override Vuetify) */
    .params-table >>> .v-data-table__wrapper > table > thead > tr > th {
        font-weight: 800 !important;
        color: #00355C !important;
    }
    /* Ensure v-simple-table header is bold (override Vuetify) */
    .params-table >>> .v-data-table__wrapper > table > tbody > tr > th {
        font-weight: 800 !important;
        color: #0a293f !important;
    }
    .custom-tooltip {
        padding: 12px;
        color: #fff;
        background: #222;
        border-radius: 8px;
        max-width: 320px;
        white-space: normal;
        position: relative;
        font-size: 1em;
        line-height: 1.4;
        box-shadow: 0 2px 8px rgba(0,0,0,0.18);
    }
    .tooltip-activator {
        cursor: help;
        text-decoration: underline;
        color: #1976D2;
    }
</style>

<script lang="js">

export default {
    name: 'OptimizationInfo',
    props: {
        optimizationOriginalParameters: {
            type: Object,
            required: true
        },
        optimizationParameters: {
            type: Object,
            required: true
        },
        optimizationStats: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
        };
    },
};


</script>
